var $ea029611d7634059$exports = {};
$ea029611d7634059$exports = {
  "buttonLabel": "Javaslatok megjelen\xEDt\xE9se",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " lehet\u0151s\xE9g");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " lehet\u0151s\xE9g");
      }
    }), " \xE1ll rendelkez\xE9sre.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Bel\xE9pett a(z) ".concat(args.groupTitle, " csoportba, amely ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " lehet\u0151s\xE9get");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " lehet\u0151s\xE9get");
          }
        }), " tartalmaz. ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", kijel\xF6lve",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Javaslatok",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", kijel\xF6lve");
  }
};
export { $ea029611d7634059$exports as default };